module.exports = __webpack_public_path__ + "static/media/king_triton.b5236f2d.jpg";